import { useEffect, useState } from "react";
import { Row, Col, Table, Spinner, Form, FormText, Accordion } from "react-bootstrap";
import { Link } from 'react-router-dom';
import './LicitacoesContratos.css';
import debounce from 'lodash.debounce';
//import CleanPagination from '../Components/CleanPagination';

export default function VerbasIndenizatorias() {
    const defaultYear = new Date().getFullYear();
    let [error, setError] = useState(false);
    let [deputados, setDeputados] = useState([]);
    let [deputado, setDeputado] = useState(null);
    let [year, setYear] = useState(defaultYear);
    let [months, setMonths] = useState([]);
    let [month, setMonth] = useState(null);
    let [verbas, setVerbas] = useState([]);
    let [verbasRubricas, setVerbasRubricas] = useState({});
    let [nomeRubricas, setNomesRubricas] = useState([]);

    const monthMap = {};
    const monthList = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

    for (let i = 1; i <= 12; i++) {
        monthMap[i] = monthList[i - 1];
    }

    const loadData = async () => {
        try {
            let result = await fetch("https://www.alepe.pe.gov.br/servicos/transparencia/dep/deputados.php?leg=-16");
            let deputados = await result.json();
            setDeputados(deputados);
        } catch {
            setError(true);
        }
    }

    const loadAvailableMonths = async () => {
        if (deputado && year) {
            let result = await fetch(`https://www.alepe.pe.gov.br/servicos/transparencia/adm/verbaindenizatoria-dep-meses.php?dep=${deputado}&ano=${year}`);
            let monthData = await result.json();
            let allowedMonths = (year == limitYear ? monthData.filter((month) => month.mes > limitMonth) : monthData)
            setMonths(allowedMonths);
        } else {
            setMonths([]);
        }
    }

    const loadVerbas = async () => {
        if (deputados && year && month) {
            let result = await fetch(`https://www.alepe.pe.gov.br/servicos/transparencia/adm/verbaindenizatoria.php?dep=${deputado}&ano=${year}&mes=${month}`);
            setVerbas(await result.json());
        } else {
            setVerbas([]);
        }
    };

    let years = [];
    let currentYear = new Date().getFullYear();
    let limitYear = currentYear - 5;
    let limitMonth = (new Date().getMonth() + 1) % 12;

    while (currentYear >= limitYear) {
        years.push(currentYear);
        currentYear--;
    }

    const getRubricasByVerba = async (docid, newMap) => {
        let result = await fetch("https://www.alepe.pe.gov.br/servicos/transparencia/adm/verbaindenizatorianotas.php?docid=" + docid);
        newMap[docid] = await result.json();
    };

    const loadVerbasRubricas = async () => {
        const newMap = {};
        const promises = [];

        verbas.forEach(verba => {
            promises.push(getRubricasByVerba(verba.docid, newMap));
        });

        await Promise.all(promises);

        setVerbasRubricas(newMap);
    };

    const loadNomesRubricas = async () => {
        let result = await fetch("https://www.alepe.pe.gov.br/servicos/transparencia/adm/verbaindenizatoria-rubricas.php?ano=" + year);
        setNomesRubricas(await result.json());
    };

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        loadAvailableMonths();
    }, [deputado, year]);

    useEffect(() => {
        loadNomesRubricas()
        setMonth("");
        setVerbas([]);
    }, [year]);

    useEffect(() => {
        loadVerbas();
    }, [month]);

    useEffect(() => {
        loadVerbasRubricas();
    }, [verbas]);

    return <Row>
        <Col xs="12">
            <p><small>Você está em <a href="/financas">Prestação de Contas</a> / Verbas Indenizatórias</small></p>
        </Col>
        <Col>
            <Col xs="12" style={{ height: '25px' }}>
                <p>Filtros de Busca</p>
                
            </Col>
            {!error ? <Form>
                <Row>
                    <Col md={4}>
                        <Form.Group controlId="parlamentar">
                            <Form.Control
                                as="select"
                                onChange={(e) => { setDeputado(e.target.value); setYear(defaultYear) }}
                                name="parlamentar">
                                <option value="">Deputado</option>
                                {deputados.map((deputado) => { return <option key={deputado.id} value={deputado.id}>{deputado.nome}</option> })}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Group controlId="ano">
                            <Form.Control
                                as="select"
                                onChange={(e) => { setYear(e.target.value) }}
                                value={year}
                                name="ano">
                                {years.map((year) => { return <option key={year} value={year}>{year}</option> })}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        {deputado && (Array.isArray(months) && months.length) > 0 ? <Form.Group controlId="mes">
                            <Form.Control
                                as="select"
                                onChange={(e) => {setMonth(e.target.value)}}
                                value={month}
                                name="mes">
                                <option value="">Mês</option>
                                {months.map((month) => { return <option key={month.mes} value={month.mes}>{monthMap[month.mes]}</option> })}
                            </Form.Control>
                        </Form.Group> : (deputado) ? <p style={{ marginTop: "10px" }}>Não há registros para este deputado em {year}.</p>: <p>Selecione um deputado para escolher o mês.</p>}
                    </Col>
                </Row>
            </Form> :  <p>Houve um erro ao carregar as informações, por favor tente novamente.</p> }
        </Col>
        <Col xs={12} className="mt-4">
            {verbas.map((verba) => 
                <Row>
                    <Col xs={12}>
                        <h3>{verba.tipo === "P" ? "PEDIDO" : "COMPLEMENTO"} Nº {verba.numero} - R$ {Number(verba.total.replace(",", ".")).toFixed(2)}</h3>
                    </Col>
                    <Col xs={12} className="mt-2">
                        {
                            verbasRubricas[verba.docid] ? <Accordion defaultActiveKey="0" className='mb-5'>
                            {verbasRubricas[verba.docid].map((rubrica, index) => <div>
                                <Accordion.Item eventKey={index}>
                                    <Accordion.Header>{nomeRubricas[Number(rubrica.rubrica) - 1]?.nome_categoria}</Accordion.Header>
                                    <Accordion.Body>
                                        <p><b>Data: </b>{rubrica.data}</p>
                                        <p><b>CNPJ: </b>{rubrica.cnpj}</p>
                                        <p><b>Empresa: </b>{rubrica.empresa}</p>
                                        <p><b>Valor: </b> R${Number(rubrica.valor.replace(",", ".")).toFixed(2)}</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </div>) }
                            </Accordion> : null
                        }
                    </Col>
                </Row>
            )}
        </Col>
    </Row>
}